import apiFetch from '../../apiFetch'

export default function (idControlSemen, token) {
  return apiFetch({endPoint: `ControlSemen/eliminarControlSemen?idControlSemen=` + idControlSemen, method: 'GET', body: null, token: token})
}
